module.exports = __webpack_public_path__ + "img/patient-enrollment.1b57f916.svg";